module.exports = __webpack_public_path__ + "media/story_video.547b15cd.mp4";